import { createBrowserRouter } from 'react-router';
import Routes from './Routes';

const Router = createBrowserRouter(Routes);

export default Router;
